<template>
  <div class="mr-3 v-theme--light">
    <h6 class="fs-6 fw-bold mt-4 mb-4 opacity-75">AUDIO</h6>
    <div class="row mb-2 py-0">
      <div class="col">
        <v-select
            hide-details="auto"
            class="small mt-2"
            :label="i18n.global.t('pages.vehicles.form.iniFileSetting.record.soundOn')"
            v-model="form.sound_on"
            :items="selectSoundOn"
            :clearable="false"
            :disabled="(selectDefault && readonlyInputs.includes('sound_on')) || isInstallationOffice"
            :error-messages="errors[errorKeyPrefix + '.sound_on']"
        />
      </div>
      <div class="col"></div>
    </div>
  </div>
</template>

<script>
import i18n from '@/lang/i18n';

export default {
  props: {
    modelValue: {},
    formInputs: {},
    selectDefault: {
      type: Boolean,
      default: false,
    },
    isOperationOffice: {
      type: Boolean,
      default: false,
    },
    isInstallationOffice: {
      type: Boolean,
      default: false,
    },
    errors: {},
  },
  data() {
    return {
      readonlyInputs: [],
      errorKeyPrefix: 'initial_params.record',
      selectSoundOn: [
        i18n.global.t('pages.vehicles.form.iniFileSetting.record.selectSoundOnOn'),
        i18n.global.t('pages.vehicles.form.iniFileSetting.record.selectSoundOnOff')
      ],
    };
  },
  watch: {
    formInputs: {
      handler() {
        if (!this.formInputs?.form?.record) return;
        const key = Object.keys(this.formInputs.default_params)[0];
        this.readonlyInputs = Object.keys(
          this.formInputs.default_params[key]?.parameters?.record ?? []
        );
      },
    },
  },
  computed: {
    i18n() {
      return i18n;
    },
    form: {
      get() {
        return this.modelValue || {};
      },
      set(value) {
        this.$emit('update:modelValue', value);
      },
    },
  },
};
</script>